import {TimelineMax, TweenMax, Linear, ExpoScaleEase} from 'gsap';
const CustomEase = require('../../../../vendors/CustomEase');
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');

// console.log(CustomEase)


const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');
    let texture;



    const bgImg = Shortcuts.getSprite('introPart1Bg', TextureCache, 'bgImg');
    const bg = new PIXI.Container();
    bgImg.anchor.x = 0.5;
    bgImg.anchor.y = 0.32;
    bgImg.scale.x = 1.15;
    bgImg.scale.y = 1.15;
    bg.position.x = sizes.coverWidth / 2;
    bg.addChild(bgImg);

    const solder2Img1 = Shortcuts.getSprite('introPart1Solder2', TextureCache, 'solder2Img1');
    texture = new PIXI.Texture(solder2Img1.texture);

    const solder2Img2 = new PIXI.Sprite(texture);
    solder2Img2.name = 'solder2Img2';
    solder2Img2.scale.x = -1;

    const solder2Cont = new PIXI.Container();
    const solder2 = new PIXI.Container();

    solder2Cont.addChild(solder2Img1);
    solder2Cont.addChild(solder2Img2);
    solder2Cont.pivot.x = 0.2 * solder2Img1.width;
    solder2Cont.pivot.y = 0.5 * solder2Img1.width;

    solder2.position.x = 0.133 * sizes.coverWidth;
    solder2.position.y = 0.29 * sizes.coverHeight;
    solder2.addChild(solder2Cont);

    const solder1BgImg1 = Shortcuts.getSprite('introPart1Solder1Bg', TextureCache, 'solder1BgImg');
    texture = new PIXI.Texture(solder1BgImg1.texture);

    const solder1BgImg2 = new PIXI.Sprite(texture);
    solder1BgImg2.name = 'solder1BgImg2';

    const solder1Bg = new PIXI.Container();

    solder1BgImg2.scale.x = -1;
    solder1BgImg1.anchor.x = 0.5;
    solder1BgImg2.anchor.x = -solder1BgImg1.anchor.x;
    solder1BgImg1.anchor.y = solder1BgImg2.anchor.y = 0.5;
    solder1Bg.addChild(solder1BgImg1);
    solder1Bg.addChild(solder1BgImg2);


    const solder1Img = Shortcuts.getSprite('introPart1Solder1', TextureCache, 'solder1Img');
    const solder1 = new PIXI.Container();
    solder1Img.anchor.x = 0.45;
    solder1Img.anchor.y = 0.5;
    solder1.addChild(solder1Img);

    const solderBlur = new PIXI.filters.BlurFilter(20);
    solder1.filters = [solderBlur];

    solder1.position.x = solder1Bg.position.x = 0.3 * sizes.coverWidth;
    solder1.position.y = solder1Bg.position.y = 0.5 * sizes.coverHeight;

    bg.z = 0.5;
    solder2.z = -0.5;
    solder1Bg.z = 0.2;
    solder1.z = 0.4;

    cont.addChild(bg);
    cont.addChild(solder2);
    cont.addChild(solder1Bg);
    cont.addChild(solder1);

    cont.scale.x = cont.scale.y = sizes.width / sizes.coverWidth;

    instance.cont = cont;
    instance.width = sizes.coverWidth;
    instance.height = sizes.coverHeight;
    instance.bg = bg;
    instance.solder1 = solder1;
    instance.solder1Bg = solder1Bg;
    instance.solder2 = solder2;
    instance.solderBlur = solderBlur;

    instance.parallaxLayers = [bg, solder2, solder1, solder1Bg];
    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}

const _constructTimeline = instance => {
    const tl = new TimelineMax({paused: true});
    const d1 = 4.5, d2 = 9;

    TweenMax.set([instance.bg, instance.solder1, instance.solder1Bg, instance.solder2], {alpha: 0});
    TweenMax.set(instance.bg.position, {y: instance.height});
    TweenMax.set(instance.bg.scale, {x: 1.15, y: 1.15});
    TweenMax.set(instance.solder1.position, {x: -0.5 * instance.width, y: 2.5 * instance.height});
    TweenMax.set(instance.solder1.scale, {x: 3, y: 3});
    TweenMax.set(instance.solderBlur, {blur: 10});
    TweenMax.set(instance.solder1Bg.position, {x: -0.1 * instance.width, y: 2.1 * instance.height});
    TweenMax.set(instance.solder1Bg.scale, {x: 1.95, y: 1.95});
    TweenMax.set(instance.solder2.position, {x: -0.1 * instance.width, y: 1.2 * instance.height});
    TweenMax.set(instance.solder2.scale, {x: 1.35, y: 1.35});

    tl.set([instance.bg, instance.solder1, instance.solder1Bg, instance.solder2], {alpha: 0});
    tl.set(instance.bg.position, {y: instance.height});
    tl.set(instance.bg.scale, {x: 1.15, y: 1.15});
    tl.set(instance.solder1.position, {x: -0.5 * instance.width, y: 2.5 * instance.height});
    tl.set(instance.solder1.scale, {x: 3, y: 3});
    tl.set(instance.solderBlur, {blur: 10});
    tl.set(instance.solder1Bg.position, {x: -0.1 * instance.width, y: 2.1 * instance.height});
    tl.set(instance.solder1Bg.scale, {x: 1.95, y: 1.95});
    tl.set(instance.solder2.position, {x: -0.1 * instance.width, y: 1.2 * instance.height});
    tl.set(instance.solder2.scale, {x: 1.35, y: 1.35});

    tl.to([instance.bg, instance.solder1, instance.solder1Bg, instance.solder2], 0.1, {alpha: 1});
    tl.to(instance.bg.position, d1, {y: 0, ease: Linear.easeInOut}, 'in');
    tl.to(instance.bg.scale, d1, {x: 1, y: 1, ease: ExpoScaleEase.config(1.15, 1)}, 'in');
    tl.to(instance.solder1.scale, d1, {x: 1, y: 1, ease: ExpoScaleEase.config(3, 1)}, 'in');
    tl.to(instance.solder1Bg.scale, d1, {x: 1, y: 1, ease: ExpoScaleEase.config(1.95, 1)}, 'in');
    tl.to(instance.solder2.scale, d1, {x: 1, y: 1, ease: ExpoScaleEase.config(1.35, 1)}, 'in');
    tl.to(instance.solderBlur, d1, {blur: 0}, 'in');
    tl.to(instance.solder1.position, d1, {y: 0.5 * instance.height, ease: CustomEase.create('slightEase', 'M0,0,C0.248,0.306,0.694,0.844,1,1')}, 'in');
    tl.to(instance.solder1.position, d1, {x: 0.3 * instance.width,  ease: Linear.easeInOut}, 'in');
    tl.to(instance.solder1Bg.position, d1, {x: 0.3 * instance.width, y: 0.5 * instance.height, ease: Linear.easeInOut}, 'in');
    tl.to(instance.solder2.position, d1, {x: 0.133 * instance.width, y: 0.29 * instance.height, ease: Linear.easeInOut}, 'in');

    tl.to([instance.bg, instance.solder1, instance.solder1Bg, instance.solder2], 0.1, {alpha: 1}, 'out');
    tl.to(instance.bg.position, d2, {y: -0.87 * instance.height, ease: Linear.easeInOut}, 'out');
    tl.to(instance.bg.scale, d2, {x: 0.87, y: 0.87, ease: ExpoScaleEase.config(1.15, 1)}, 'out');
    tl.to(instance.solder1.scale, d2, {x: 0.33, y: 0.33, ease: ExpoScaleEase.config(1, 0.33)}, 'out');
    tl.to(instance.solder1Bg.scale, d2, {x: 0.54, y: 0.54, ease: ExpoScaleEase.config(1, 0.54)}, 'out');
    tl.to(instance.solder2.scale, d2, {x: 0.4, y: 0.4, ease: ExpoScaleEase.config(1, 0.4)}, 'out');
    tl.to(instance.solderBlur, d2, {blur: 0}, 'out');
    tl.to(instance.solder1.position, d2, {x: (0.3 + 0.4) * instance.width, y: (0.5 - 0.9) * instance.height, ease: Linear.easeInOut}, 'out');
    tl.to(instance.solder1Bg.position, d2, {x: (0.3 + 0.2) * instance.width, y: (0.5 - 1) * instance.height, ease: Linear.easeInOut}, 'out');
    tl.to(instance.solder2.position, d2, {x: (0.133 + 0.3) * instance.width, y: (0.29 - 0.85) * instance.height, ease: Linear.easeInOut}, 'out');

    tl.to([instance.bg, instance.solder1, instance.solder1Bg, instance.solder2], 0, {alpha: 0}, 'out+=' + d2 * 0.9);


    instance.timeline = tl;
    return tl;
}


function SolderTimelineConstructor(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.refDuration = 13.5;
    constructor.totalDuration = 4.5 + 9 + 0.5;

    return constructor;
}


module.exports = SolderTimelineConstructor;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/IntroPart1_Solder.js